module.exports = __webpack_public_path__ + "img/functionality@2x.18729bf5.png";